export default () => ({
  blogs: {},
  blog: null,
  filters: {
    types: [],
    themes: [],
    // authors: [],
    // countries: [],
    // regions: [],
  },
});
